"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apComposition = exports.sequenceS = exports.sequenceT = void 0;

var function_1 = require("./function");

function curried(f, n, acc) {
  return function (x) {
    var combined = Array(acc.length + 1);

    for (var i = 0; i < acc.length; i++) {
      combined[i] = acc[i];
    }

    combined[acc.length] = x;
    return n === 0 ? f.apply(null, combined) : curried(f, n - 1, combined);
  };
}

var tupleConstructors = {
  1: function _(a) {
    return [a];
  },
  2: function _(a) {
    return function (b) {
      return [a, b];
    };
  },
  3: function _(a) {
    return function (b) {
      return function (c) {
        return [a, b, c];
      };
    };
  },
  4: function _(a) {
    return function (b) {
      return function (c) {
        return function (d) {
          return [a, b, c, d];
        };
      };
    };
  },
  5: function _(a) {
    return function (b) {
      return function (c) {
        return function (d) {
          return function (e) {
            return [a, b, c, d, e];
          };
        };
      };
    };
  }
};

function getTupleConstructor(len) {
  if (!tupleConstructors.hasOwnProperty(len)) {
    tupleConstructors[len] = curried(function_1.tuple, len - 1, []);
  }

  return tupleConstructors[len];
}

function sequenceT(F) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var len = args.length;
    var f = getTupleConstructor(len);
    var fas = F.map(args[0], f);

    for (var i = 1; i < len; i++) {
      fas = F.ap(fas, args[i]);
    }

    return fas;
  };
}

exports.sequenceT = sequenceT;

function getRecordConstructor(keys) {
  var len = keys.length;

  switch (len) {
    case 1:
      return function (a) {
        var _a;

        return _a = {}, _a[keys[0]] = a, _a;
      };

    case 2:
      return function (a) {
        return function (b) {
          var _a;

          return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
        };
      };

    case 3:
      return function (a) {
        return function (b) {
          return function (c) {
            var _a;

            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
          };
        };
      };

    case 4:
      return function (a) {
        return function (b) {
          return function (c) {
            return function (d) {
              var _a;

              return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
            };
          };
        };
      };

    case 5:
      return function (a) {
        return function (b) {
          return function (c) {
            return function (d) {
              return function (e) {
                var _a;

                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
              };
            };
          };
        };
      };

    default:
      return curried(function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        var r = {};

        for (var i = 0; i < len; i++) {
          r[keys[i]] = args[i];
        }

        return r;
      }, len - 1, []);
  }
}

function sequenceS(F) {
  return function (r) {
    var keys = Object.keys(r);
    var len = keys.length;
    var f = getRecordConstructor(keys);
    var fr = F.map(r[keys[0]], f);

    for (var i = 1; i < len; i++) {
      fr = F.ap(fr, r[keys[i]]);
    }

    return fr;
  };
}

exports.sequenceS = sequenceS;

function apComposition(F, G) {
  return function (fga) {
    return function (fgab) {
      return F.ap(F.map(fgab, function (h) {
        return function (ga) {
          return G.ap(h, ga);
        };
      }), fga);
    };
  };
}

exports.apComposition = apComposition;